/* globals playerSc $ param */
import svgcenter from './interface.js'
import envmap from './envmap.js'

jQuery(document).ready(function () {
  svgcenter()
  $("[type='button'][track]").mouseover(function () {
    var track = $(this).attr('track')
    var elements = $('[track=' + track + ']')
    if (track === playerSc.getCurrentTrack() + 1) {
      elements.attr('hover', 'true')
      elements.attr('active', 'true')
      elements.attr('idle', 'false')
    } else {
      elements.attr('hover', 'true')
      elements.attr('active', 'false')
      elements.attr('idle', 'false')
    }
  })
  $("[type='button'][track]").mouseout(function () {
    var track = $(this).attr('track')
    var elements = $('[track=' + track + ']')

    if (track === playerSc.getCurrentTrack() + 1) {
      elements.attr('hover', 'false')
      elements.attr('active', 'true')
      elements.attr('idle', 'false')
    } else {
      elements.attr('hover', 'false')
      elements.attr('active', 'false')
      elements.attr('idle', 'true')
    }
  })
  $("[type='button']").click(function () {
    var trackNumber = $(this).attr('track')
    playerSc.play(trackNumber - 1)

    $('#center').delay(2000).fadeIn()
    $('#interface').fadeOut()
    $('#liste').fadeOut()
    $('#center2').fadeOut()
    $('#covers').fadeOut()
    envmap.warpIn()

    if (typeof param !== 'undefined') {
      envmap.setParams(param[trackNumber])
    }
  })

  $('#center').click(function () {
    envmap.warpOut()
    $('#center').fadeOut(1000)
    $('#center2').fadeIn(3000)
    $('#liste').delay(1000).fadeIn(1000)
    $('#interface').delay(1000).fadeIn(1000)
    $('#covers').delay(1000).fadeIn()
  })

  var timeoutId
  $('#center').hover(function () {
    if (!timeoutId) {
      timeoutId = window.setTimeout(function () {
        timeoutId = null // EDIT: added this line
        envmap.warpOut()
        $('#center').fadeOut(1000)
        $('#center2').fadeIn(3000)
        $('#liste').delay(1000).fadeIn(1000)
        $('#interface').delay(1000).fadeIn(1000)
        $('#covers').delay(1000).fadeIn()
      }, 1000)
    }
  },

 function () {
   if (timeoutId) {
     window.clearTimeout(timeoutId)
     timeoutId = null
   } else {

   }
 })

  $('#center').mouseover(function () {
    $('#center0').fadeIn()
    $('.center_track').fadeOut()
  })

  $('#center').mouseout(function () {
    $('#center0').fadeOut()
    $('.center_track').fadeIn()
  })

  var timeout2Id
  $('#interface').hover(function () {
    if (!timeout2Id) {
      timeout2Id = window.setTimeout(function () {
        timeoutId = null // EDIT: added this line
        envmap.warpIn()
        $('#center').fadeIn(1000)
        $('#center2').fadeOut(1000)
        $('#liste').fadeOut(500)
        $('#interface').fadeOut()
        $('#covers').fadeOut()
        $('#currenttrack').fadeIn(1000)
      }, 1000)
    }
  },
function () {
  if (timeout2Id) {
    window.clearTimeout(timeout2Id)
    timeout2Id = null
  } else {

  }
})
})
